import store from 'store';
import { profileSelector } from 'store/selectors/profile-selectors';
import { getAnalyticsService } from 'services/analytics';
import { toNumber } from 'lodash';

const identifyAnalyticsUser = async (): Promise<void> => {
  const user = profileSelector(store.getState());
  if (!user?.id || !user?.email) return;

  const companyId = user.companyId ? toNumber(user.companyId) : undefined;

  getAnalyticsService().identifyUser({
    id: user.id,
    email: user.email,
    name: `${user.firstName} ${user.lastName}`,
    companyId,
  });
};

export default identifyAnalyticsUser;
